import { useEffect, useState } from "react";
import { getPublikationen } from "../services/cdn.services";
import "./publikationen.page.css";
import { PublikationenType } from "../types/publikationen.type";
import LanguageButton from "../components/languageButton.component";
import React from "react";

function Publikationen(
    props: Readonly<{
        isEnglish: boolean;
        setIsEnglish: (newValue: boolean) => void;
    }>
) {
    const { isEnglish, setIsEnglish } = props;

    //Fetch expertise data
    useEffect(() => {
        const fetchData = async () => {
            setPublikationenData(await getPublikationen());
        };
        fetchData();
    }, [])
    const [publikationenData, setPublikationenData] = useState<PublikationenType[] | undefined>(undefined);
    
    const [showElements, setShowElements] = useState<number>(0);
    useEffect(() => {
        if (showElements === publikationenData?.length) {
            return;
        }
    
        const timeout = setTimeout(() => {
            setShowElements(showElements + 1);
        }, 50);
    
        return () => clearTimeout(timeout);
    }, [showElements]);
    
    const years: string[] = [];
    
    return (
        <div id="publikationen" className="standard-page">
                <div className="flex column items-center">

                    <div className="flex gap w-100 between items-center mt-5">
                        <div className="remove-on-phone" style={{width: 60}} />
                        <h5>{isEnglish ? "Publications" : "Publikationen"}</h5>
                        <LanguageButton onToggle={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} />
                    </div>
                    
                    <div className="publikationen-container">
                        {publikationenData?.sort((a, b) => b.jahr.localeCompare(a.jahr))
                            .map((value: PublikationenType, index: number) => {
                                const year = value.jahr?.substring(0, 4);
                                const isNewYear = !years.includes(year);

                                if (isNewYear) years.push(year);

                                return (
                                    <div key={index} className="w-100">
                                        {isNewYear && (
                                            <div className={`${showElements <= index ? "invisible-item" : "visible-item"} year-container`}>
                                                <div className="year-line" />
                                                <h6>{year}</h6>
                                                <div className="year-line" />
                                            </div>
                                        )}
                                        
                                        <div className={`${showElements <= index ? "invisible-item" : "visible-item"} flex gap-4`}>
                                            <div className="flex column" style={{maxWidth: "100%"}}>
                                                <div className="flex column gap-1">
                                                    <h4 className="titel">{isEnglish ? value.en_titel : value.titel}</h4>
                                                    <h3>{isEnglish ? value.en_author : value.autor}</h3>
                                                </div>
                                                {value.link ? (
                                                    <a className="flex pb-4" href={value.link}>
                                                        <p className="beschreibung">
                                                        {(isEnglish ? value.en_beschreibung : value.beschreibung)
                                                            ?.split('\n')
                                                            .map((line, i, arr) => (
                                                            <React.Fragment key={i}>
                                                                {line}
                                                                {i < arr.length - 1 && <br />}
                                                            </React.Fragment>
                                                            ))}
                                                        </p>
                                                    </a>
                                                    ) : (
                                                    <div className="flex pb-4">
                                                        <p className="beschreibung">
                                                        {(isEnglish ? value.en_beschreibung : value.beschreibung)
                                                            ?.split('\n')
                                                            .map((line, i, arr) => (
                                                            <React.Fragment key={i}>
                                                                {line}
                                                                {i < arr.length - 1 && <br />}
                                                            </React.Fragment>
                                                            ))}
                                                        </p>
                                                    </div>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
        </div>
    );
}

export default Publikationen;